import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

export interface WetagStore {
  enabledWeTags: Record<string, boolean>;
  setEnabledWeTags: (enabledWeTags: Record<string, boolean>) => void;
}

export const useWetagStore = createStoreWithSubscribe<WetagStore>(
  (set) => ({
    enabledWeTags: {},
    setEnabledWeTags: (enabledWeTags: Record<string, boolean>) => {
      set({ enabledWeTags });
    },
  }),
  { name: 'WetagStore', trace: true }
);

export const useWeTagShallowStore = createShallowStore(useWetagStore);
